import { Stack, styled } from '@mui/material'
import { Button } from 'bs-unified-ui'

const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'isSelected',
})<{ isSelected?: boolean }>(({ isSelected = false, theme }) => ({
  '&.MuiButton-text': {
    color: theme.foreground.black4,
    fontSize: 12,
  },
  height: 24,
  minWidth: 'unset',
  padding: '4px 8px',
  ...(isSelected
    ? {
        backgroundColor: theme.background.sectionBg,
        '&.MuiButton-text': {
          color: theme.foreground.black,
          fontSize: 12,
        },
      }
    : {}),
}))

interface Props {
  mode?: boolean
  onChange?: () => void
}

const CustomSwitch = ({ mode = true, onChange }: Props) => (
    <Stack direction="row" spacing={0.5}>
      <StyledButton variant="text" onClick={onChange} isSelected={mode}>
        Visual
      </StyledButton>
      <StyledButton variant="text" onClick={onChange} isSelected={!mode}>
        HTML
      </StyledButton>
    </Stack>
  )

export default CustomSwitch
